<style src="./style.scss">
</style>

<script lang="ts">
  import { afterUpdate } from "svelte";

  import { navigate } from "svelte-navigator";
  import Icon from "svelte-icon";
  import { mutation, query } from "svelte-apollo";

  import Button from "@components/button";
  import Checkbox from "@components/checkbox";
  import DangerZone from "@components/dangerZone";
  import Footer from "@components/footer";
  import Header from "@components/header";
  import Spinner from "@components/spinner";
  import { useLocation } from "svelte-navigator";

  import { TERMS_LINK } from "@utils";

  import BackButton from "@assets/icons/back.svg";
  import FeaturesStep from "./steps/features.svelte";
  import ReasonStep from "./steps/reason.svelte";
  import ContactStep from "./steps/contact.svelte";
  import ConfirmStep from "./steps/confirm.svelte";

  import { CANCEL_SUBSCRIPTION_MUTATION } from "./cancelSubscritpion.mutation.ts";
  import { CANCELLATION_REASONS_QUERY } from "./cancellationReasons.query.ts";

  const cancelSubscritpionMutation = mutation(CANCEL_SUBSCRIPTION_MUTATION);

  const location = useLocation();

  const cancellationReasonsQuery = query(CANCELLATION_REASONS_QUERY);

  let isLoading = false;
  let step = "features";
  let options = [
    {
      label:
        "Toda a minha evolução na plataforma de ensino será excluída e não poderá ser recuperada",
      checked: false,
      id: "option-1",
    },
    {
      label:
        "Não terei mais acesso ilimitado ao PROFESSOR ONLINE ao vivo dos planos SILVER e GOLD.",
      checked: false,
      id: "option-2",
    },
    {
      label:
        "Não poderei mais participar das AULAS AO VIVO ilimitadas (CNA Go Live) dos planos SILVER e GOLD.",
      checked: false,
      id: "option-3",
    },
  ];
  let reasons = [];
  let cancellationReasonIds = [];

  afterUpdate(() => {
    if ($cancellationReasonsQuery?.data) {
      const { cancellationReasons } = $cancellationReasonsQuery.data;

      reasons = cancellationReasons.map(({ name, id }) => ({
        label: name,
        id,
        checked: false,
      }));
    }
  });

  function goBack() {
    navigate("/overview");
  }

  function getNextPaymentRemainingDays(nextPaymentDate) {
    const today = new Date();
    const next = new Date(nextPaymentDate);

    const diffTime = Math.abs(next - today);

    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  }

  function goStep(next: string) {
    step = next;
  }

  function onReasonChange(value: boolean, index: number) {
    if (value) {
      cancellationReasonIds.push(reasons[index].id);

      return;
    }

    cancellationReasonIds = cancellationReasonIds.filter(
      (id) => id !== reasons[index].id
    );
  }

  async function unsubscribe() {
    isLoading = true;

    const { data, errors } = await cancelSubscritpionMutation({
      variables: {
        input: {
          cancellationReasonIds,
        },
      },
      errorPolicy: "all",
    });

    if (errors) {
      isLoading = false;

      return;
    }

    if (data.cancelSubscription) {
      const { status, endAt, amount } = data.cancelSubscription;

      navigate("/unsubscribe-success", {
        state: {
          isGuaranteed: status === "REFUNDED",
          endAt,
          amount,
        },
      });
    }
  }
</script>

<Header />

{#if isLoading}
  <Spinner />
{:else}
  <div class="unsubscribe">
    <div>
      <div class="unsubscribe__content">
        <div class="unsubscribe__back">
          <div on:click="{goBack}">
            <Icon data="{BackButton}" size="24px" stroke="transparent" />
            <div>Voltar</div>
          </div>
        </div>
      </div>
      <div class="unsubscribe__content">
        {#if step === "features"}
          <FeaturesStep
            nextPaymentRemainingDays="{getNextPaymentRemainingDays(
              $location.state.nextPaymentDate
            )}"
            goBack="{goBack}"
            nextStep="{() => goStep('reason')}" />
        {/if}

        {#if step === "reason"}
          <ReasonStep
            nextPaymentRemainingDays="{getNextPaymentRemainingDays(
              $location.state.nextPaymentDate
            )}"
            goBack="{goBack}"
            reasons="{reasons}"
            onReasonChange="{onReasonChange}"
            nextStep="{() => goStep('contact')}" />
        {/if}

        {#if step === "contact"}
          <ContactStep
            nextPaymentRemainingDays="{getNextPaymentRemainingDays(
              $location.state.nextPaymentDate
            )}"
            nextPaymentDate="{$location.state.nextPaymentDate}"
            goBack="{goBack}"
            nextStep="{() => goStep('confirm')}" />
        {/if}

        {#if step === "confirm"}
          <ConfirmStep
            remainingDays="{$location.state.remainingDays}"
            nextPaymentRemainingDays="{getNextPaymentRemainingDays(
              $location.state.nextPaymentDate
            )}"
            goBack="{goBack}"
            unsubscribe="{unsubscribe}"
            options="{options}" />
        {/if}
      </div>
    </div>
  </div>
{/if}
<div class="desktop-only">
  <Footer />
</div>
